/**
 * Copyright 2026 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */

import React from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import T from "i18n-react";
import { Button } from "@mui/material";

const UploadBtn = ({ disabled, onClick }) => {
  return (
    <Button
        startIcon={<ArrowUpwardIcon sx={{ fontSize: 16 }} />}
        variant="contained"
        size="medium"
        disabled={disabled}
        onClick={onClick}
        sx={{ width: 180, heigh: 36 }}
      >
        {T.translate("buttons.upload_file")}
      </Button>
  );
};

export default UploadBtn;
